var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#338AF3;}\n\t.st3{fill:#FFDA44;}\n\t.st4{fill:#6DA544;}\n\t.st5{fill:#A2001D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.7,467.5C152.8,495.6,202.5,512,256,512s103.2-16.4,144.3-44.5L256,445.2L111.7,467.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.3,44.5C359.2,16.4,309.5,0,256,0S152.8,16.4,111.7,44.5L256,66.8L400.3,44.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512,256c0-84.7-50.7-169.8-111.7-211.5H111.7C44.3,90.6,0,168.1,0,256c0,87.9,44.3,165.4,111.7,211.5h288.6 C467.7,421.4,512,343.9,512,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.5,417.6c-3.5-3-85.7-74.4-85.7-161.6S238,97.4,241.5,94.4L256,82l14.5,12.4c3.5,3,85.7,74.4,85.7,161.6 S274,414.6,270.5,417.6L256,430L241.5,417.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M333.9,256c0-77.9-77.9-144.7-77.9-144.7s-77.9,66.8-77.9,144.7c0,23.8,7.3,46.6,17.4,66.8h121 C326.6,302.6,333.9,279.8,333.9,256L333.9,256z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.9,256c0,23.8-7.3,46.6-17.4,66.8L256,333.9l-60.5-11.1c-10.1-20.2-17.4-42.9-17.4-66.8H333.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,400.7c0,0,37.5-32.2,60.5-77.9h-121C218.5,368.5,256,400.7,256,400.7L256,400.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.9,211.5h100.2L256,261.6L205.9,211.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.3,244.9h33.4V345h-33.4L239.3,244.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGu);
export default __webpack_public_path__ + "static/media/gu.0d4a60c0dba15de2be2535cfa0c90511.svg";
export { ForwardRef as ReactComponent };